import GetStrLocalized from '../../datas/GetStrLocalized'
import SearchInputCentred from "./SearchInputCentred";
import { HcContext } from "../../types/hccontext";


interface MainSearchInputProps {
	language: string;
	searchValue: string;
	hcContext: HcContext;
}

function MainSearchInputCentred({ language, searchValue, hcContext }: Readonly<MainSearchInputProps>) {
	return <SearchInputCentred placeholder={GetStrLocalized(language, "search")} searchValue={searchValue} searchPath={'/' + language + '/' + GetStrLocalized(language, "searchFolderName") + '/'}
		language={language} hcContext={hcContext} />
}

export default MainSearchInputCentred
